<div [ngClass]="colorClass()" class="side-by-side overflow-hidden">
    <div [ngClass]="[verticalPadding(), containerType(), containerPadding()]">
        <div class="row justify-content-center">
            <div
                #sideBySideImage
                [ngClass]="[
                    type() === 'right' ? 'order-0 order-lg-1' : '',
                    imageClass()
                ]"
                class="d-flex align-self-center position-relative"
            >
                <!-- some assets are not yet hosted on bynder -->
                @if (!inlineVideoId() && !isExternalImage()) {
                <img
                    [alt]="imageAlt()"
                    [class]="'img-fluid w-100 ' + roundedImage()"
                    [src]="image()"
                />
                } @else if (!inlineVideoId() && isExternalImage()) {
                <img
                    brandOptimizedImage
                    [alt]="imageAlt()"
                    [ngClass]="roundedImage()"
                    [ngSrc]="image()"
                    class="optimized-image"
                    sizes="(max-width: 991px) 100vw, 50vw"
                    fill
                />
                } @if (inlineVideoId() && inlineVideoLoaded) {
                <div class="ratio ratio-16x9">
                    @if (inlineVideoLoaded) {
                    <brand-video [videoData]="inlineVideoUrl"> </brand-video>
                    }
                </div>
                }
            </div>
            <div
                [ngClass]="[
                    type() === 'right' ? 'order-1 order-lg-0' : '',
                    centered() ? 'd-flex align-self-center' : '',
                    contentClass()
                ]"
            >
                <div
                    [ngClass]="[
                        contentPadding() ? contentPadding() : 'pt-4 pt-lg-0',
                        centered() ? 'align-self-center' : ''
                    ]"
                    [class]="'rounded-4 h-100 ' + contentColor()"
                >
                    <ng-template [ngTemplateOutlet]="contentRef"></ng-template>
                </div>
            </div>
        </div>
    </div>
</div>

@if (modalVideoId() && isBrowser) {
<brand-modal
    (onClose)="closeModal($event)"
    [id]="modalVideoId()"
    modalDialogClass="modal-video modal-dialog-centered modal-max-width"
    modalContentClass="bg-transparent"
>
    @if (modalVideoLoaded) {
    <brand-video [videoData]="modalVideoUrl"> </brand-video>
    }
</brand-modal>
}

<!--TEMPLATE PARTIALS-->
<ng-template #contentRef>
    @if (logo()) {
    <img #sideBySideLogo [alt]="logoAlt()" [src]="logo()" class="img-fluid" />
    } @if (headingValue() === 1 || (!headingValue() && heading())) {
    <h1 #sideBySideHeading [ngClass]="headingClass()" class="m-0">
        <ng-template [ngTemplateOutlet]="headerRef"></ng-template>
    </h1>
    } @if (headingValue() === 2 && heading()) {
    <h2 #sideBySideHeading [ngClass]="headingClass()" class="m-0">
        <ng-template [ngTemplateOutlet]="headerRef"></ng-template>
    </h2>
    } @if (headingValue() === 3 && heading()) {
    <h3 #sideBySideHeading [ngClass]="headingClass()" class="m-0">
        <ng-template [ngTemplateOutlet]="headerRef"></ng-template>
    </h3>
    } @if (headingValue() === 4 && heading()) {
    <h4 #sideBySideHeading [ngClass]="headingClass()" class="m-0">
        <ng-template [ngTemplateOutlet]="headerRef"></ng-template>
    </h4>
    } @if (headingValue() === 5 && heading()) {
    <h5 #sideBySideHeading [ngClass]="headingClass()" class="m-0">
        <ng-template [ngTemplateOutlet]="headerRef"></ng-template>
    </h5>
    } @if (description()) {
    <div
        #sideBySideDescription
        [innerHtml]="description() | translate : 'markdown'"
        class="mt-1 markdown"
    ></div>
    } @for (action of actionOrder(); track action) { @switch (action) { @case
    ('video') { @if (modalVideoId()) {
    <button
        #sideBySideModalLink
        [ngClass]="buttonClass()"
        (click)="openModal(modalVideoId())"
        class="icon-link banner--modal-btn p-0 mt-4"
    >
        <span class="icon-link-icon">
            <img
                [src]="'GLOBAL_WATCH-VIDEO_PLAY_ICON_URL' | translate"
                [alt]="'GLOBAL_WATCH-VIDEO_PLAY_ICON_ALT_TEXT' | translate"
                class="bi play-icon"
            />
        </span>
        <span [innerHtml]="'GLOBAL_WATCH-VIDEO_TEXT' | translate"></span>
    </button>
    } } @case ('button') { @if (buttonText() && buttonUrl()) {
    <div class="button">
        <a
            #sideBySideButton
            [brandHref]="buttonUrl()"
            [innerHtml]="buttonText()"
            class="btn btn-primary mt-4 me-2"
        >
        </a>
    </div>
    } } @case ('link') { @if (linkText() && linkUrl()) {
    <div class="link">
        <a
            #sideBySideLink
            [brandHref]="linkUrl()"
            [ngClass]="buttonClass()"
            class="icon-link p-0 mt-4"
        >
            <span [innerHtml]="linkText()"></span>
            <span class="icon-link-icon">
                <img
                    [src]="'GLOBAL_ARROW-RIGHT_ICON_URL' | translate"
                    [alt]="'GLOBAL_ARROW-RIGHT_ICON_ALT_TEXT' | translate"
                    class="bi arrow-icon align-baseline"
                />
            </span>
        </a>
    </div>
    } } } }
    <ng-content></ng-content>
</ng-template>
<ng-template #headerRef>
    @if (!isHidden && subheading() && subheading() !== '') {
    <small [innerHtml]="subheading()" class="subtitle d-block"></small>
    }
    <span [innerHtml]="heading()" class=""></span>
</ng-template>
